import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";

class Header extends React.Component {
  render() {
    return (
      <>
        <ProductConsumer>
          {(value) => {
            const {
              PR_code,
              PR_name,
              PR_setempty,
              PR_nrxkartonpishandan,
              aynamictoanotherInput,
              AddProChange,
              PR_save,
              PR_drowpdownchange,
              PR_checkboxchange,
              PR_getProductByCode,
              PR_newpage,
              PR_font,
              PR_display,
              setSaletSearchEmty
            } = value;

            return (
              <>
                <div style={{ marginTop: "3.5em" }}>
                  <h3
                    className="fk tc text-warning mt-5 p-3"
                    style={{ color: "white", fontSize: "30px" }}
                  >
                    زیادکردنی ناوی کاڵاکان بۆ رەفە
                  </h3>
                </div>

                <form>
                  <div
                    className="row text-warning font-weight-bold"
                    style={{ backgroundColor: "#2C3539" }}
                  >
                    <div className="col-2"></div>
                    <div className="col-1 text-right px-2 mt4">
                      <button
                        onClick={PR_newpage}
                        className={`btn btn-primary mr2`}
                      >
                        <i className="far fa-file fa-lg"></i>
                      </button>
                      <button
                        onClick={(e) => PR_save(e)}
                        className="btn btn-success"
                      >
                        <i className="far fa-save"></i>
                      </button>
                    </div>
                    <div className="col-1 text-right"></div>
                    <div className="col-2 text-right">
                      <div className="form-group">
                        <label>شێواز</label>
                        <select
                          className="form-control text-right font-weight-bold selectpicker pull-right"
                          onChange={PR_drowpdownchange}
                          name="PR_display"
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 3, "p", PR_save)
                              : null
                          }
                          value={PR_display}
                        >
                          <option value="">شێواز</option>
                          <option value="block">بە پانی</option>
                          <option value="inline">بە درێژی</option>
                          <option value="less">بە کورتی</option>
                          <option value="dolar">بە دۆلار</option>
                          <option value="dinar">بە دینار</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-1 text-right">
                      <div className="form-group">
                        <label>فۆنت</label>
                        <select
                          className="form-control text-right font-weight-bold selectpicker pull-right"
                          onChange={PR_drowpdownchange}
                          name="PR_font"
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 1, "m")
                              : null
                          }
                          value={PR_font}
                        >
                          <option value="10">10</option>
                          <option value="20">20</option>
                          <option value="30">30</option>
                          <option value="40">40</option>
                          <option value="50">50</option>
                          <option value="60">60</option>
                          <option value="70">70</option>
                          <option value="80">80</option>
                          <option value="90">90</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-2 text-right">
                      <div className="form-group">
                        <label>ناوی شتەکان</label>
                        <input
                          type="text"
                          value={PR_name}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 1, "p", PR_save)
                              : null
                          }
                          name="PR_name"
                          className="form-control text-right font-weight-bold"
                        />
                      </div>
                    </div>
                    <div className="col-1 text-right px-2">
                      <div className="form-group">
                        <label>کۆد</label>
                        <input
                          type="text"
                          onClick={setSaletSearchEmty}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(
                                  event,
                                  1,
                                  "m",
                                  PR_getProductByCode
                                )
                              : null
                          }
                          onClick={PR_setempty}
                          value={PR_code}
                          name="PR_code"
                          onChange={AddProChange}
                          className="form-control text-right font-weight-bold tc pr-4"
                        />
                      </div>
                    </div>
                    <div className="col-1 text-right  mt4">
                      <div className="row">
                        <div className="col-3"></div>
                        <div className="col-6">
                          <button
                            onClick={setSaletSearchEmty}
                            className="btn btn-dark"
                          >
                            <i className="fas fa-search-plus"></i>
                          </button>
                        </div>
                        <div className="col-3"></div>
                      </div>
                    </div>
                  </div>
                </form>
              </>
            );
          }}
        </ProductConsumer>
      </>
    );
  }
}

export default Header;
